/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import { ShareIcon } from "./ShareIcon/ShareIcon";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  price: number;
};

export const Price: FcWithoutChildren<Props> = (props) => {
  const { price } = props;

  return (
    <div css={rootStyle}>
      <p>
        <span css={yenStyle}>¥</span>
        <span css={priceStyle}>{price.toLocaleString()}</span>
        {/* TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159 */}
        <span css={taxStyle}>税込</span>
      </p>

      <div>
        {/* TODO: share dialog 表示のトリガーとなる要素 https://github.com/balus-co-ltd/spwn/issues/11449 */}
        {/* NOTE: 親の div ごと Price の props で渡すようにした方が責務の分離がきれいかも */}
        <ShareIcon height={22} width={18} />
      </div>
    </div>
  );
};

const rootStyle = css`
  display: flex;
  justify-content: space-between;
`;

const yenStyle = css`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

const priceStyle = css`
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  margin-left: 4px;
`;

const taxStyle = css`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-left: 4px;
`;
